import { defineStore } from 'pinia'
import { ref, computed } from '@nuxtjs/composition-api'

export const useAppliedDiscountCodeStore = defineStore('appliedDiscountCodeStore', () => {
  const appliedDiscountCodes = ref([])
  const totalDiscountCodeDiscount = ref(0)
  const enteredVoucherCode = ref('')

  const hasAppliedDiscountCode = computed(() => appliedDiscountCodes.value.length > 0)

  const setAppliedDiscountCodes = (discountCodes) => {
    appliedDiscountCodes.value = discountCodes || []
  }

  const setTotalDiscountCodeDiscount = (amount) => {
    totalDiscountCodeDiscount.value = amount || 0
  }

  const updateFromCart = (cart) => {
    if (cart?.appliedDiscountCodes) {
      setAppliedDiscountCodes(cart.appliedDiscountCodes)
    }
    if (cart?.totalDiscountCodeDiscount !== undefined) {
      setTotalDiscountCodeDiscount(cart.totalDiscountCodeDiscount)
    }
  }

  const clearDiscountCodes = () => {
    appliedDiscountCodes.value = []
    totalDiscountCodeDiscount.value = 0
    enteredVoucherCode.value = ''
  }

  const setEnteredVoucherCode = (code) => {
    enteredVoucherCode.value = code || ''
  }

  return {
    appliedDiscountCodes,
    totalDiscountCodeDiscount,
    enteredVoucherCode,
    hasAppliedDiscountCode,
    setAppliedDiscountCodes,
    setTotalDiscountCodeDiscount,
    setEnteredVoucherCode,
    updateFromCart,
    clearDiscountCodes
  }
})
